import React from 'react'
import PageWrapper from 'enrollment-platform/PageWrapper'

export default function PlanManagementV2Gate({
  children,
}: {
  children: React.ReactNode
}) {
  return <PageWrapper>{children}</PageWrapper>
}
